// function updateTagValue() {
//   const selectedValue = $('.hc-customer-tags').val();
//   $('.hc-tag-input').attr('value', selectedValue);
// }

// $(document).ready(function() {
//   updateTagValue();
//   $('.hc-customer-tags').on('change', updateTagValue);
// });

// $(document).on('click', '.hc-chat-trigger', function() {
//   document.querySelector('#ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
// });

// $(document).on('change', '.hc-lang-select', function() {
//   window.location =$(this).val();
// });

$(document).on('click', '.hc-chat-trigger, .trigger-chat', function(e) {
    e.preventDefault();

    console.log('🔥 HC CHAT TRIGGER CLICKED');

    function findChatButton(root) {
        if (!root) return null;

        // Directly look for the activator
        const button = root.querySelector('button[part="activator"]');

        if (button) {
            return button;
        }

        // Search through nested shadow roots
        const elements = root.querySelectorAll('*');

        for (const element of elements) {
            if (element.shadowRoot) {
                const found = findChatButton(element.shadowRoot);

                if (found) {
                    return found;
                }
            }
        }

        return null;
    }

    function tryOpenChat() {
        const chats = document.querySelectorAll('shopify-chat');

        console.log('Shopify chat elements:', chats.length);

        for (const shopifyChat of chats) {

            if (!shopifyChat.shadowRoot) {
                continue;
            }

            const chatButton = findChatButton(shopifyChat.shadowRoot);

            if (chatButton) {

                console.log('✅ CHAT BUTTON FOUND:', chatButton);

                const isOpen =
                    chatButton.getAttribute('aria-expanded') === 'true';

                console.log('Current state:', isOpen ? 'OPEN' : 'CLOSED');

                if (!isOpen) {
                    console.log('🚀 CLICKING CHAT BUTTON');
                    chatButton.click();
                } else {
                    console.log('ℹ️ CHAT IS ALREADY OPEN');
                }

                return true;
            }
        }

        return false;
    }

    // Try immediately
    if (tryOpenChat()) {
        return;
    }

    console.log('⏳ Chat not ready, waiting...');

    // Shopify may still be initializing/rebuilding the component
    let attempts = 0;

    const timer = setInterval(function() {

        attempts++;

        console.log('🔄 Attempt:', attempts);

        if (tryOpenChat()) {
            clearInterval(timer);
            return;
        }

        if (attempts >= 50) {
            clearInterval(timer);
            console.log('❌ Could not find Shopify Chat activator');
        }

    }, 100);
});